import evaluateSafeLinkOperation from 'owa-service/lib/operation/evaluateSafeLinkOperation';
import { trace } from 'owa-trace';

export default async function evaluateSafeLinkService(safeLinkUrls: string[]): Promise<string[]> {
    if (!safeLinkUrls) {
        return null;
    }

    if (safeLinkUrls.length > 0) {
        try {
            const response = await evaluateSafeLinkOperation({
                SafeLinkUrls: safeLinkUrls,
            });
            if (response?.Results) {
                return response.Results;
            }
        } catch (error) {
            trace.warn(`evaluateSafeLinkService failed with error: ${error}`);
        }
    }

    // return an array of same length and all elements are null
    return safeLinkUrls.map(() => null);
}
